/**
 * Обязательная пометка под каждым видео.
 *
 * Требование адвокатской рекламы штата Нью-Йорк: материал, показывающий
 * клиента или результат, обязан нести пометку и оговорку про прошлые
 * результаты. В подвале сайта она уже стоит, но подвал — это НЕ «под видео»:
 * читатель, увидевший ролик в середине страницы, до подвала может не дойти
 * вовсе, а на встроенном плеере оговорки нет.
 *
 * Один компонент на все места намеренно: текст оговорки обязан совпадать
 * дословно везде, а два экземпляра формулировки разъезжаются молча.
 */
export const ATTORNEY_ADVERTISING_NOTE =
  'Attorney Advertising. Prior results do not guarantee a similar outcome.';

export default function AttorneyAdvertisingNote({ className = '' }: { className?: string }) {
  return (
    <p data-adv-note="1" className={`font-body text-navy/55 text-[11px] leading-snug mt-2 ${className}`}>
      <strong className="font-semibold text-navy/70">Attorney Advertising.</strong>{' '}
      Prior results do not guarantee a similar outcome.
    </p>
  );
}
